import React, { Component } from "react";
import axios from 'axios';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import api from './api';
import CheckIcon from '@material-ui/icons/Check';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from "@material-ui/core/styles";
import SendIcon from '@material-ui/icons/Send';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

const useStyles = theme => ({
  menu:{
      fontSize:'0.75rem',
  }
});

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class MobileMessages extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
      	messages: [],
      	message:{},
      	types:[
      			{id: 'KM', name: 'Solicitud de kilometraje'},
		      	{id: 'TURNO', name: 'Información de turno'},]
      }
  	}

    componentDidMount() {
    	this.getMessages(this.props.endpoint)
    }

    getMessages = (endpoint) => {
		const token = localStorage.getItem('userToken')
		axios.get(endpoint,{ headers: {"Authorization" : `Bearer ${token}`} })
	     .then(res => {
	     		var messages = res.data
	     		this.setState({messages})
	      })
	      .catch(err =>{console.log(err)
	      })
    }

    handleChange = (e) => {
    	var message = this.state.message
    	message[e.target.name] = e.target.value;
    	this.setState({message: message})
    }

    handleSubmit = (e) => {
    	e.preventDefault()
	    var formData = new FormData();
	    formData.set(this.props.model+ "[" + this.props.model_key +"]", this.props.id);
	    formData.set("text", this.state.message.text);
	    formData.set("title", this.state.message.title);
	    let self = this
	    const token = localStorage.getItem('userToken')
	    axios.post(this.props.endpoint,
	       formData,
	       {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
	       )
	      .then((response)=> {
		  		self.setState({
		  			openSuccess: true,
		  			success_message: 'Mensaje enviado con éxito', 
		  			severity:'success'})
			    	this.getMessages(this.props.endpoint)

	      })
	      .catch(function (error) {
		  		self.setState({
		  			openSuccess: true,
		  			success_message: 'Ha ocurrido un error al cargar la relación. Por favor contacté a su adminsitrador', 
		  			severity:'warning'})
	    })

    }

  	handleCloseSuccess = () =>{
  		this.setState({openSuccess: false, success_message:'', severity: ''})
  	}

	render() {
		const classes = this.props.classes;
		return(
			<React.Fragment>
				{(this.state.messages.map((val, idx)=> {
					return (
						<React.Fragment>
							<Card className="mt-2" >
							  <CardContent>
							    <Typography color="primary" style={{fontSize: '0.75rem'}} >
							      	{val.Title} - {val.Type} - {val.Created} {(val.Read !== '1') ? <CheckIcon style={{color: 'grey'}}/> : (val.OKFlag !== '1') ? <DoneAllIcon style={{color: 'blue'}}/> : <DoneAllIcon style={{color: 'green'}} />}
							    </Typography>
							    <Typography className="ml-2"  color="inherit" style={{fontSize: '0.70rem'}}  >
							    	{val.Text}
							    </Typography>
							  </CardContent>
							</Card>
						</React.Fragment>
					)
				}))}
				<Card className="mt-2 mb-4" >
				  <CardContent>
				    <Typography color="primary" style={{fontSize: '0.75rem'}} >
				       <TextField
							id="type"
							name="type"
							select
							margin="normal"
							className="mr-2 mt-1"
							InputLabelProps={{
								shrink: true
							}}
			 			  	onChange={this.handleChange}
						    value={this.state.message.type}
							inputProps={{style:{fontSize: '0.75rem'}}}
				          	InputProps={{
					            startAdornment: <InputAdornment position="start" ><Typography variant="caption">Tipo</Typography></InputAdornment>,
					            style:{fontSize: '0.75rem'}
								}}
				        >
				          {this.state.types.map((option) => (
				            <MenuItem key={option.id} value={option.id} className={classes.menu}>
				              {option.name}
				            </MenuItem>
				          ))}
				        </TextField>
				    </Typography>
				    <Typography className="ml-2"  color="inherit" style={{fontSize: '0.70rem'}}  >
						<TextField
							id="text"
							name="text"
							margin="normal"
							fullWidth
							className="mr-2 mt-1"
							InputLabelProps={{
								shrink: true
							}}
			 			  	onChange={this.handleChange}
							value={this.state.message.text}
							inputProps={{style:{fontSize: '0.75rem'}}}
						  	InputProps={{
						        startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Mensaje:</Typography></InputAdornment>,
								//endAdornment: <InputAdornment position="end" ><SendIcon disbaled onClick={(e)=>{this.handleSubmit(e)}}/></InputAdornment>
							}}
						/>
				    </Typography>
				  </CardContent>
				</Card>
				<Snackbar open={this.state.openSuccess} autoHideDuration={5000} onClose={this.handleCloseSuccess}>
					<Alert onClose={this.handleCloseSuccess} severity={this.state.severity}>
					  {this.state.success_message}
					</Alert>
				</Snackbar>
			</React.Fragment>
		)
	}
}

export default withStyles(useStyles)(MobileMessages);

